export type CrmPage = {
  url: string;
  name: string;
  exact: boolean;
  omitUrl: boolean;
  activeBasePath?: string;
  extraActivePaths?: string[];
};

export const CRM_BOOKS_COMPANY_QUERY_KEY = "company";

export const CRM_PAGE = {
  ENTITIES: {
    url: "",
    name: "Entities",
    exact: true,
    omitUrl: false,
    extraActivePaths: ["/entity"],
  },
  HOME: { url: "/home", name: "Home", exact: true, omitUrl: false },
  ACCOUNT_INFO: {
    url: "/accountinfo",
    name: "Account Info",
    exact: false,
    omitUrl: false,
  },
  FILINGS: {
    url: "/new-filings?FILING_STATUS=ONGOING",
    name: "Filings",
    exact: false,
    omitUrl: false,
  },
  BOOKS: { url: "/books", name: "Books", exact: false, omitUrl: true },
  SALES_TAX: {
    url: "/sales-tax",
    name: "Sales Tax",
    exact: false,
    omitUrl: true,
  },
  TICKETS: {
    url: "/company-tickets",
    name: "Tickets",
    exact: false,
    omitUrl: false,
  },
  CHAT: { url: "/chat", name: "Chat", exact: false, omitUrl: false },
  DOCUMENTS: {
    url: "/documents",
    name: "Documents",
    exact: false,
    omitUrl: false,
    activeBasePath: "/documents",
  },
  TEAM_SETTINGS: {
    url: "/team-settings",
    name: "Team Settings",
    exact: false,
    omitUrl: false,
  },
  BILLING: { url: "/billing", name: "Billing", exact: false, omitUrl: false },
  INTERNAL_TEAM_SETTINGS: {
    url: "/internal-team-settings",
    name: "Internal Team Settings",
    exact: false,
    omitUrl: false,
  },
  ESTIMATED_TAX: {
    url: "/advance-tax",
    name: "Estimated Tax",
    exact: false,
    omitUrl: false,
  },
  STATE_INCOME_TAX: {
    url: "/state-income-tax",
    name: "State Income Tax",
    exact: false,
    omitUrl: false,
  },
  ACTION_CENTRE: {
    url: "/todolist",
    name: "Action Centre",
    exact: false,
    omitUrl: false,
  },
  AUTO_FILL: {
    url: "/autofills",
    name: "Auto-Fill",
    exact: false,
    omitUrl: false,
  },
  STATE_COMPLIANCE: {
    url: "/state-compliance",
    name: "State Compliance",
    exact: false,
    omitUrl: false,
  },
  RA: { url: "/registeredagent", name: "RA", exact: false, omitUrl: false },
  MAILROOM: { url: "/mail", name: "Mailroom", exact: false, omitUrl: false },
  NEXUS_TRACKER: {
    url: "/sales-tax",
    name: "Nexus Tracker",
    exact: false,
    omitUrl: false,
  },
  PERKS: { url: "/perks", name: "Perks", exact: false, omitUrl: false },
  AUDIT_LOGS: {
    url: "/auditlog",
    name: "Audit logs",
    exact: false,
    omitUrl: false,
  },
} satisfies Record<string, CrmPage>;

export const ADMIN_QUICK_NAV_PAGES: CrmPage[] = [
  CRM_PAGE.ENTITIES,
  CRM_PAGE.HOME,
  CRM_PAGE.ACCOUNT_INFO,
  CRM_PAGE.FILINGS,
  CRM_PAGE.BOOKS,
  CRM_PAGE.TICKETS,
  CRM_PAGE.CHAT,
  CRM_PAGE.DOCUMENTS,
  CRM_PAGE.TEAM_SETTINGS,
  CRM_PAGE.BILLING,
  CRM_PAGE.INTERNAL_TEAM_SETTINGS,
  CRM_PAGE.ESTIMATED_TAX,
  CRM_PAGE.STATE_INCOME_TAX,
  CRM_PAGE.ACTION_CENTRE,
  CRM_PAGE.AUTO_FILL,
  CRM_PAGE.STATE_COMPLIANCE,
  CRM_PAGE.RA,
  CRM_PAGE.MAILROOM,
  CRM_PAGE.NEXUS_TRACKER,
  CRM_PAGE.PERKS,
  CRM_PAGE.AUDIT_LOGS,
];
